// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Mr9Ld","requiredAsterisk":"Info_requiredAsterisk__3jKFb"};